{
  "Net EXP includes only confirmed segments; gaps are excluded. The rate covers only the uninterrupted segment after recovery.": "純獲得経験値は確認済みの区間のみを合計し、欠損区間は含みません。効率は復旧後の連続区間のみで計算します。",
  "Net EXP includes only confirmed segments; gaps are excluded. The average uses confirmed segment duration.": "純獲得経験値は確認済みの区間のみを合計し、欠損区間は含みません。平均効率は確認済み区間の時間で計算します。",
  "First session gap": "記録内の最初の欠落",
  "Ready": "レベルアップ可能",
  "{p0}m": "{p0}分",
  "{p0}h {p1}m": "{p0}時間{p1}分",
  "{p0}d {p1}h": "{p0}日{p1}時間",
  "Map unconfirmed": "マップ未確認",
  "Map pending confirmation": "確認待ちのマップ",
  "Waiting for map recognition": "マップ認識待ち",
  "Recognizing map": "マップの認識",
  "Finishing": "終了処理中",
  "Confirming": "確認中",
  "Net EXP": "純増経験値",
  "Gained": "獲得",
  "4h 57m": "4時間57分",
  "8h 51m": "8時間51分",
  "Victoria Island / Forest of Wisdom": "ビクトリアアイランド / 知恵の森",
  "Maple Log": "Maple Log",
  "Widget": "ウィジェット",
  "Loading widget…": "ウィジェットを読み込み中…",
  "Your panel will appear when ready": "準備が整うとパネルが表示されます",
  "": "",
  "Waiting for readings": "読み取り待ち",
  "Gathering samples": "サンプルの収集",
  "No rate available": "効率データなし",
  "Since recovery": "復旧後の効率",
  "Confirming an EXP change.": "経験値 の変更を確認しています。",
  "Waiting for a fresh level reading.": "新しいレベルの測定値を待っています。",
  "Cross-level EXP evidence is missing.": "クロスレベル 経験値 の証拠がありません。",
  "Waiting for a readable game frame.": "読み取り可能なゲーム画面を待機しています。",
  "The EXP change could not be confirmed in time.": "経験値 の変更を時間内に確認できませんでした。",
  "Capture continuity was interrupted during confirmation.": "確認中にキャプチャの継続が中断されました。",
  "EXP / hour": "経験値 / 時間",
  "Waiting for complete EXP evidence.": "完全な経験値証拠を待っています。",
  "Some EXP readings could not be confirmed, so session net EXP is unavailable. The rate covers only the uninterrupted segment after recovery.": "一部の 経験値 読み取り値が確認できなかったため、セッション 純増経験値 が利用できません。この料金は、回復後の中断されていないセグメントのみを対象としています。",
  "Recovery baseline": "復旧後の開始点",
  "Last confirmed": "最終確認",
  "EXP/h": "経験値/時間",
  "Showing the last confirmed values while checking.": "チェック中に最後に確認された値を表示します。",
  "The last reading is too old to show as a current rate.": "最新の測定値が古すぎるため、現在のレートとして表示できません。",
  "Last 60s: {p0} EXP/h\nSession average: {p1} EXP/h\nDifference: {p2} EXP/h\nLast sample: {p3}\nArrows appear at 4% and hide 1.5s after returning to 2%, with recognition-delay protection. Window edges and cross-level gains may be estimated.": "過去 60 秒: {p0} 経験値/h\nセッション平均: {p1} 経験値/h\n差分: {p2} 経験値/h\n最後のサンプル: {p3}\n認識遅延保護機能により、矢印は 4% で表示され、2% に戻った後 1.5 秒間非表示になります。ウィンドウのエッジとクロスレベルのゲインを推定できます。",
  "Elapsed": "経過",
  "EXP / h": "経験値 / 時間",
  "Mesos / h": "メル / 時間",
  "Map": "マップ",
  "Recognizing": "認識する",
  "Start": "開始",
  "Pause": "一時停止",
  "Resume": "再開",
  "End": "終了",
  "Confirming EXP": "経験値を確認中",
  "HP": "HP",
  "MP": "MP",
  "Lv.": "Lv.",
  "Level up": "レベルアップまで",
  "Full level": "1レベル分",
  "Change": "変更",
  "Net": "純増",
  "Live metrics": "リアルタイム統計",
  "Idle": "待機中",
  "Recording": "記録中",
  "Paused": "一時停止中",
  "Ended": "終了",
  "Interrupted": "中断",
  "{p0}h": "{p0}時間",
  "EXP reading details": "経験値の読み取りについて",
  "Close": "閉じる",
  "Loading preview…": "プレビューを読み込み中…",
  "Widget layout preview": "ウィジェットのレイアウトのプレビュー",
  "Start balance": "開始時の所持メル",
  "Display unavailable. Reopen the widget.": "表示できません。ウィジェットを開き直してください。",
  "Reading details when opened": "開いた時点の読み取り情報",
  "Waiting to start": "記録開始待ち",
  "Waiting for valid data": "有効なデータを待機中",
  "No chart data": "グラフデータなし",
  "Waiting for a sample point": "サンプル点を待機中",
  "{seconds}/{window}s": "{seconds}/{window}秒",
  "Waiting for character": "キャラクター確認待ち"
}
